<template>
  <div class="brochure-selection__item">
    <div class="brochure-selection__item-image">
      <picture>
        <img :src="`${brochure.imageUrl}?format=webp`" :alt="brochure.name" loading="lazy"/>
      </picture>
    </div>
    <div class="brochure-selection__item-text">
      <div class="brochure-selection__item-title" :class="{ 'brochure-selection__item-titleTs': brandName === Brand.Travelsphere }">{{brochure.name}}</div>
      <div class="brochure-selection__item-id">{{brochure.code}}</div>
    </div>
  </div>
</template>

<script>
import {Brand} from './../../../brand.js';

export default {
  props: ['brochure', 'brandName'],
  data() {
    return {
      Brand
    };
  }
};
</script>